import React, {Component} from 'react';
import MaterialIcon from '../../MaterialIcon';

class SelectBox extends Component {

    componentDidMount() {
        if (this.props.load) {
            this.props.load();
        }
    }

    render() {
        return (
            <div className={`form-select ${this.props.className ?? ""}`}>
                {!this.props.hideArrow &&
                <span className={`${this.props.className ? "editorial-table-select-arrow" : ""} arrow`}>
                    <MaterialIcon icon="keyboard_arrow_down" size={24}/>
                </span>
                }
                <select className={this.props.className ? "editorial-table-select-inner" : ""} onChange={this.props.handleChangeSelect} value={this.props.selectValue ? this.props.selectValue : ""}>
                    {this.props.showDefault && (
                        <option value="" disabled>Please select an option</option>
                    )}
                    {this.props.selectArray.length > 0 ?
                        this.props.selectArray.map((x, y) => <option key={y} value={x.value}>{x.label}</option>) :
                        <option value="" disabled>Please select an option</option>
                    }
                </select>
            </div>
        )
    }
}

export default SelectBox;
